import React, {useState} from "react";
import "../../style/custom/wide-panel.scss";
import Form from "formsy-react";
import { clearFormData, getFormData, setFormData } from "../../components/manager/form";
import AltTextField from "../../components/bootstrap/input-alt";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import CheckAddOn from "../bootstrap/check-add-on"
import { window } from "window-or-global";

const WidePanel = (props) => {
  const { 
    products, 
    selectedProduct, 
    getPlanSpeedLabel,
    addons, 
    handleConfirmPlanOrder,
    onRemoveProduct, 
    onAddProduct
  } = props;


  // const [withAddon, setWithAddon] = useState(false);
  // const [additionalCost, setAdditionCost] = useState(0);

  function getDescription(value) {
    let str = value;

    let desc = str.split(" ")[0];
    return desc;
  }


  return (
    <div className="wide-panel-container">
      <div className="wide-panel-heading">
        <a href="/">
          <i className="fas fa-times close-icon" aria-hidden="true"/>
        </a>
      </div>
      <div className="wide-panel-title">
        <p className="panel-title">{"Change Plan"}</p>
      </div>

      <div className="wide-panel-voucher-container">
        <Form className="voucher-form" onValidSubmit={props.handleOnSubmit}>
          <div className="voucher-row">
            <AltTextField
              name="voucherCode"
              required
              hideRequiredMark
              autoComplete="off"
              placeholder={"Have a voucher code? enter it here!"}
              validations={{
                maxLength: 20,
                isAlphanumeric: true,
                isExisty: true,
              }}
              validationErrors={{
                isExisty: (
                  <FormattedMessage id="validation.errors.required.coupon" />
                ),
                maxLength: (
                  <FormattedMessage id="validation.errors.maxLength50" />
                ),
                isAlphanumerical: (
                  <FormattedMessage id="validation.errors.isAlphanumeric" />
                ),
              }}
              defaultValue={props.voucherCode}
              className="voucher-field"
            />

            <input type="submit" className="vw-voucher-button" value="Apply" />

            {/* <Button
              className="vw-clear-voucher"
              onClick={() => {props.voucherCode("")}}
            >
              {"Clear"}
            </Button> */}
          </div>
        </Form>
      </div>

      <div className="wide-panel-product-slider">
        <div className="product-slider-container">
        
          {products
            .filter((p) => !p.hidden && p.type === "internet")
            .map((product) => {
              return (
                <div
                  key={product?.id}
                  className={
                    product?.id === selectedProduct?.id
                      ? "product-selected-card"
                      : "product-card"
                  }
                  onClick={() => {
                    props.setProduct(product);
                  }}
                >
                  <div
                    className={
                      product?.id === selectedProduct?.id
                        ? "product-desc-selected"
                        : "product-desc"
                    }
                  >
                    {getDescription(product.description)}
                  </div>
                  <div
                    className={
                      product?.id === selectedProduct?.id
                        ? "product-title-selected"
                        : "product-title"
                    }
                  >
                    {product.name}
                  </div>
                
                  <hr />

                  <div className="price-speed">
                    <div
                      className={
                        product?.id === selectedProduct?.id
                          ? "price-selected"
                          : "price"
                      }
                      style={{
                        textDecoration: product.originalValue
                          ? "line-through"
                          : undefined,
                      }}
                    >
                      {`$${
                        product.originalValue
                          ? product.originalValue
                          : product.value
                      }`}{" "}
                      <span className="per-month">{"per month"}</span>
                    </div>

                    <p className={product?.id === selectedProduct?.id
                          ? "per-month-alt-selected"
                          :"per-month-alt"}>{"per month"}</p>

                    {(product || {}).voucherName && (
                      <div className="product-voucher">
                        {`$${product.value} ${product.voucherName}`}
                      </div>
                    )}

                    <div
                      className={
                        product?.id === selectedProduct?.id
                          ? "price-subdetails-selected"
                          : "product-subdetails"
                      }
                    >
                      {`Typical Speed: ${getPlanSpeedLabel(product.name)} Mbps`}
                    </div>
                  </div>

                  <Button
                    className={
                      product?.id === selectedProduct?.id
                        ? "selected-btn"
                        : "product-button"
                    }
                  >
                    {product?.id === selectedProduct?.id
                      ? "Selected"
                      : "Select Plan"}
                  </Button>
                </div>
              );
            })}

         
        </div>
      </div>
      
      <div className="wide-panel-add-ons">
        <CheckAddOn
          title={"Available Add ons:"}
          addons={addons}
          selectedProductIds={[]}
          onRemoveProduct={onRemoveProduct}
          onAddProduct={onAddProduct}
          voucherCode={props.voucherCode}
        />

      </div>
      <div className="wide-panel-voucher-actions">
        <a href="/">
          <Button className="cancel-confirm">{"Cancel"}</Button>
        </a>
        <Button onClick={handleConfirmPlanOrder} disabled={!selectedProduct} className="confirm-proceed">{"Confirm"}</Button>
      </div>
    </div>
  );
};

export default WidePanel;
